export const privateTransactionsTypes = {
    withdraw: 0,
    deposit: 1,
    common: 2,
};
